
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_atmmg_25",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_atmmg_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_atmmg_1",
  "refresh": "awsui_refresh_1d2i7_atmmg_48",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_atmmg_1",
  "root": "awsui_root_1d2i7_atmmg_81",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_atmmg_1",
  "hide-dismiss-button": "awsui_hide-dismiss-button_1d2i7_atmmg_158",
  "hidden": "awsui_hidden_1d2i7_atmmg_161",
  "focus-lock": "awsui_focus-lock_1d2i7_atmmg_165",
  "position-top": "awsui_position-top_1d2i7_atmmg_173",
  "position-center": "awsui_position-center_1d2i7_atmmg_176",
  "small": "awsui_small_1d2i7_atmmg_190",
  "medium": "awsui_medium_1d2i7_atmmg_193",
  "large": "awsui_large_1d2i7_atmmg_196",
  "x-large": "awsui_x-large_1d2i7_atmmg_199",
  "xx-large": "awsui_xx-large_1d2i7_atmmg_202",
  "custom-width": "awsui_custom-width_1d2i7_atmmg_205",
  "max": "awsui_max_1d2i7_atmmg_208",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_atmmg_208",
  "custom-height": "awsui_custom-height_1d2i7_atmmg_213",
  "container": "awsui_container_1d2i7_atmmg_218",
  "custom-height-container": "awsui_custom-height-container_1d2i7_atmmg_258",
  "content": "awsui_content_1d2i7_atmmg_264",
  "no-paddings": "awsui_no-paddings_1d2i7_atmmg_269",
  "custom-height-content": "awsui_custom-height-content_1d2i7_atmmg_273",
  "header": "awsui_header_1d2i7_atmmg_278",
  "header--text": "awsui_header--text_1d2i7_atmmg_290",
  "footer": "awsui_footer_1d2i7_atmmg_294",
  "footer--rounded": "awsui_footer--rounded_1d2i7_atmmg_303",
  "dismiss-control": "awsui_dismiss-control_1d2i7_atmmg_315",
  "modal-open": "awsui_modal-open_1d2i7_atmmg_319"
};
  